/**
 * サービスプロバイダーの選択肢。**値は `server/app/idp/constants.py` と同じ**
 * (画面が勝手な値を送ると API が 400 で弾く)。
 */
export const KIND_LABEL: Record<string, string> = {
  saml: "SAML SSO",
  oidc: "OIDC",
  link: "リンク",
};

export const NAME_ID_ATTRIBUTES = [
  { value: "username", label: "ユーザー名" },
  { value: "email", label: "メールアドレス" },
  { value: "employee_id", label: "社員番号(ユーザー属性 employee_id)" },
];

export const NAME_ID_FORMATS = [
  { value: "unspecified", label: "unspecified(指定なし)" },
  { value: "emailAddress", label: "emailAddress(メール形式)" },
  { value: "persistent", label: "persistent(永続)" },
  { value: "transient", label: "transient(一時)" },
];

export const SIGNATURE_ALGORITHMS = [
  { value: "RSA_SHA256", label: "RSA-SHA256(推奨)" },
  { value: "RSA_SHA1", label: "RSA-SHA1(古い SP 向け)" },
  { value: "RSA_SHA512", label: "RSA-SHA512" },
];

export const AUTHN_CONTEXTS = [
  { value: "PasswordProtectedTransport", label: "PasswordProtectedTransport(既定)" },
  { value: "unspecified", label: "指定しない" },
];

/** 属性設定の「ユーザー項目」。上4つは Keycloak の組み込み、それ以外はユーザー属性。 */
export const USER_FIELDS = [
  { value: "username", label: "ユーザー名(username)" },
  { value: "email", label: "メールアドレス(email)" },
  { value: "firstName", label: "名(firstName)" },
  { value: "lastName", label: "姓(lastName)" },
  { value: "employee_id", label: "社員番号(employee_id)" },
];

export const LOGO_MAX_BYTES = 64 * 1024;
export const LOGO_ACCEPT = "image/png,image/jpeg,image/svg+xml";
export const SECRET_MASK = "•••発行済み";
export const SESSION_HOURS_DEFAULT = 8;

/** 一覧の「状態」の色。Keycloak と食い違っているものは目立たせる。 */
export function statusColor(status: string): string {
  if (status === "有効") return "green";
  if (status === "無効") return "default";
  if (status === "Keycloakに無い") return "red";
  return "orange";
}
